<template>
  <div id="nutshell" class="nutshell active homepageSec" :class="{ true: isShowing }">

    <div id="innerNutshell">

      <div id="canvas">

        <div class="spaceLogo">
          <img class="bsd" src="../../assets/icons/bsd_icon_nutshell.svg" alt="Blacksheepdesign - Design, web & marketing studio " title="Blacksheepdesign - Design, web & marketing studio" />
        </div>

        <div id="sayings" class="contentWrap flex_wrap col verticalAlign">
          <div class="col_row space_main">
            <h1 id="bsdTitle" class="txtWhite unbold">Blacksheepdesign</h1>
            <div id="say" class="sayingsWrapper">
              <h1><vue-typer :text='sayingList'
                :repeat='Infinity'
                :shuffle='true'
                initial-action='typing'
                :pre-type-delay='1500'
                :type-delay='100'
                :pre-erase-delay='2000'
                :erase-delay='100'
                erase-style='backspace'
                :erase-on-complete='false'
                caret-animation='phase'>
              </vue-typer></h1>
            </div>
          </div>
        </div>

        <div id="cta">
          {{findLogoColour}}
          <!-- This section is hard coded due difficultly adding a v-on:click function to dynamic content -->
          <p class="txtWhite">We do good things for nice people all over the place.<br/><br/>
          Well, we do one good thing - communication.  Communication has many forms, and as a full-service agency we can help your business find its voice.  Just like a good pair of jandals, <router-link class="txtWhite" to="/theflock">our flock</router-link> is ideal for almost <router-link class="txtWhite" to="/services">any job</router-link> - including design, web, marketing and of course, communications.
          <br/><br/>Have a look at some of <a v-on:click="scrollTo('ourwork')" class="txtWhite">our creative solutions</a> and <span class="link" @click="openContact2">let's have a yarn</span>.</p>
        </div>

        <div class="innerWrapper">
          <div class="draggable" id="icon1"><img class="letter" src="../../assets/icons/B.svg" alt="" /></div>
          <div class="draggable" id="icon2"><img class="letter" src="../../assets/icons/L.svg" alt="" /></div>
          <div class="draggable" id="icon3"><img class="letter" src="../../assets/icons/A.svg" alt="" /></div>
          <div class="draggable" id="icon4"><img class="letter" src="../../assets/icons/C.svg" alt="" /></div>
          <div class="draggable" id="icon5"><img class="letter" src="../../assets/icons/K.svg" alt="" /></div>
          <div class="draggable" id="icon6"><img class="letter" src="../../assets/icons/S.svg" alt="" /></div>
          <div class="draggable" id="icon7"><img class="letter" src="../../assets/icons/H.svg" alt="" /></div>
          <div class="draggable" id="icon8"><img class="letter" src="../../assets/icons/E.svg" alt="" /></div>
          <div class="draggable" id="icon9"><img class="letter" src="../../assets/icons/E.svg" alt="" /></div>
          <div class="draggable" id="icon10"><img class="letter" src="../../assets/icons/P.svg" alt="" /></div>
          <div class="draggable" id="icon11"><img class="letter" src="../../assets/icons/D.svg" alt="" /></div>
          <div class="draggable" id="icon12"><img class="letter" src="../../assets/icons/E.svg" alt="" /></div>
          <div class="draggable" id="icon13"><img class="letter" src="../../assets/icons/S.svg" alt="" /></div>
          <div class="draggable" id="icon14"><img class="letter" src="../../assets/icons/I.svg" alt="" /></div>
          <div class="draggable" id="icon15"><img class="letter" src="../../assets/icons/G.svg" alt="" /></div>
          <div class="draggable" id="icon16"><img class="letter" src="../../assets/icons/N.svg" alt="" /></div>
        </div>
      </div>

      <div id="scrollDown" v-on:click="scrollTo('ourwork')">
        <p>Neat stuff down here</p>
        <img src="../../../static/white-arrow-down.svg" alt="" title="" />
      </div>

    </div>

  </div>
</template>

<script>

import canvas from '../../assets/js/canvasAnimation.js'
import menuTransitions from '../../assets/js/menu.js'
import animateScrollTo from 'animated-scroll-to'
// import hammer from 'hammerjs'
import Axios from 'axios'
import { VueTyper } from 'vue-typer'
const interact = require('interactjs')

export default {
  data () {
    return {
      isShowing: false,
      metaTitle: '',
      metaDescription: '',
      cta: '',
      sayings: ['BSD'],
      sayingList: ['is a design, web & marketing studio', 'makes great coffee', 'is certified by Google'],
      logoColour: 'black',
      pageName: '',
      pageOrder: [
        '/',
        '/casestudies'
      ],
      navigationDirection: 'forward'
    }
  },
  metaInfo () {
    return {
      title: 'Full Service Creative Agency',
      meta: [
        { vmid: 'description', name: 'description', content: 'A creative agency packing web, design, brands, digital marketing, and communications into one clever team. Great work going worldwide from Palmerston North.' }
      ]
    }
  },
  computed: {
    findLogoColour: function () { // request the logo colour
      this.$bus.$emit('bsdLogo', {bsdColour: this.logoColour})
      // return this.logoColour
    }
  },
  methods: {
    openContact () {
      // console.log('opening menu.........................')
      this.isShowing = true
      this.$bus.$emit('openContact', {isShowing: true})  // Emit an event
    },
    openContact2 () {
      // console.log('step 1')
      this.isShowing = true
      this.$bus.$emit('openContact2', {isShowing: true})
    },
    canvasAnimate () {
      var windowWidth = screen.width
      if (windowWidth > 1024) {
        setTimeout(function () {
          canvas.canvasAnimation()
        }, 2750)
      }
    },
    startDragDrop (elm) {
      // dragdrop.randomisePlacement()
      // target elements with the "draggable" class
      interact('.draggable')
        .draggable({
          inertia: true, // enable inertial throwing
          restrict: { // keep the element within the area of it's parent
            restriction: 'parent',
            endOnly: true,
            elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
          },
          autoScroll: true, // enable autoScroll
          onmove: dragMoveListener, // call this function on every dragmove event
          onend: function (event) { // call this function on every dragend event
            var textEl = event.target.querySelector('img')
            textEl && (textEl.textContent =
              'moved a distance of ' + (Math.sqrt(Math.pow(event.pageX - event.x0, 2) + Math.pow(event.pageY - event.y0, 2) | 0)).toFixed(2) + 'px')
          }
        })

      function dragMoveListener (event) {
        var target = event.target
        // keep the dragged position in the data-x/data-y attributes
        var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
        var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy

        // translate the element
        target.style.webkitTransform =
        target.style.transform = 'translate(' + x + 'px, ' + y + 'px)'

        // update the posiion attributes
        target.setAttribute('data-x', x)
        target.setAttribute('data-y', y)
      }

      // this is used later in the resizing and gesture demos
      window.dragMoveListener = dragMoveListener
    },
    fadeIn () {
      console.log('ready')
      setTimeout(function () {
        var canvasDiv = document.getElementById('canvas')
        var cta = document.getElementById('cta')
        var bsdLogo = document.getElementsByClassName('spaceLogo')
        var sayings = document.getElementById('bsdTitle')
        var saysWrapp = document.getElementById('say')
        bsdLogo = bsdLogo[0]
        var browserSize = window.innerWidth || document.body.clientWidth
        var deviceMaxSize = 1024
        var arrowDown = document.getElementById('scrollDown')
        if (browserSize > deviceMaxSize) {
          console.log('first option')
          window.Velocity(canvasDiv, { opacity: 1 }, { duration: 800 })
          window.Velocity(cta, { opacity: 1 }, { duration: 800, delay: 2500 })
          window.Velocity(bsdLogo, { opacity: 1 }, { duration: 800, delay: 1500 })
          window.Velocity(sayings, { opacity: 1 }, { duration: 800, delay: 1500 })
          window.Velocity(saysWrapp, { opacity: 1 }, { duration: 800, delay: 2000 })
          window.Velocity(arrowDown, { opacity: 1 }, { duration: 800, delay: 3500 })
        } else {
          console.log('second option')
          window.Velocity(canvasDiv, { opacity: 1 }, { duration: 800 })
          window.Velocity(cta, { opacity: 1 }, { duration: 800, delay: 1900 })
          window.Velocity(bsdLogo, { opacity: 1 }, { duration: 800, delay: 1500 })
          window.Velocity(sayings, { opacity: 1 }, { duration: 800, delay: 1500 })
          window.Velocity(saysWrapp, { opacity: 1 }, { duration: 800, delay: 1500 })
          window.Velocity(arrowDown, { opacity: 1 }, { duration: 800, delay: 1500 })
        }
      }, 300)
    },
    nextPage () {
      this.navigationDirection = 'forward'
      const currentPage = this.pageOrder.indexOf(this.$route.path)
      const nextPage = this.pageOrder[currentPage + 1]
      // console.log(nextPage)
      if (nextPage) { this.$router.push(nextPage) }
    },
    prevPage () {
      this.navigationDirection = 'reverse'
      const currentPage = this.pageOrder.indexOf(this.$route.path)
      const prevPage = this.pageOrder[currentPage - 1]
      if (prevPage) { this.$router.push(prevPage) }
    },
    processScroll (e) {
      if (e.deltaY < 0) {
        this.prevPage()
        // console.log('prevPage will load')
      }
      if (e.deltaY > 0) {
        this.nextPage()
        // console.log('nextPage will load')
      }
    },
    initScroll () {
      /* var mc = new hammer.Manager(window)
      var swipe = new hammer.Swipe()

      mc.add(swipe)
      mc.on('swipedown', ev => {
        this.prevPage()
      })
      mc.on('swipeup', ev => {
        this.nextPage()
      }) */

      var scrollTimer = 0
      var lastScrollFireTime = 0

      window.addEventListener('wheel', e => {
        if (this.pageOrder.indexOf(this.$route.path) + 1) {
          var minScrollTime = 1400
          var now = new Date().getTime()

          if (!scrollTimer) {
            if (now - lastScrollFireTime > minScrollTime) {
              this.processScroll(e) // fire immediately on first scroll
              lastScrollFireTime = now
            }
          }
        }
      })
    },
    listenOut () { // on click this closes menu
      // menuTransitions.hideHeader()
    },
    closeMenuDown () { // after timeout this closes menu
      setTimeout(function () {
        menuTransitions.hideHeader()
      }, 2800)
    },
    isMenuOpen () { // on page load if menu is open it will close
      var pageHeader = document.getElementById('header')
      if (pageHeader.classList.contains('true')) {
        // console.log('yay')
        this.isShowing = true
      } else {
        document.getElementById('header').classList.remove('true')
        document.getElementById('movingHeader').classList.remove('true')
        document.getElementById('menuBtn').classList.remove('true')
        var linodes = document.getElementById('menu').childNodes
        for (var a = 0; a < linodes.length; a++) {
          // console.log(linodes[a])
          if (linodes[a].textContent !== ' ') {
            linodes[a].classList.remove('fadeIn')
          }
        }
      }
    },
    scrollTo (destination) { // scroll to a div position
      // console.log(destination)
      document.getElementById('ourwork').classList.add('in-viewport')
      var destinationWrap = document.getElementById(destination)
      const options = {
        speed: 1000
      }
      animateScrollTo(destinationWrap, options)
      this.animateHTML().init()
    },
    animateHTML () {
      // console.log('ready')
      var elems
      var windowHeight
      function init () {
        elems = document.querySelectorAll('.hidden')
        windowHeight = window.innerHeight
        addEventHandlers()
        checkPosition()
      }
      function addEventHandlers () {
        window.addEventListener('scroll', checkPosition)
        window.addEventListener('resize', init)
      }
      function checkPosition () {
        for (var i = 0; i < elems.length; i++) {
          var positionFromTop = elems[i].getBoundingClientRect().top
          if (positionFromTop - windowHeight <= 0) {
            elems[i].className = elems[i].className.replace(
              'hidden',
              'fade-in-element'
            )
          }
        }
      }
      return {
        init: init
      }
    },
    getData () {
      Axios.get(this.$root.$data.site + '/wp-json/wp/v2/pages/70').then(response => {
        this.metaTitle = response.data.acf.meta_title
        this.metaDescription = response.data.acf.meta_description
        this.cta = response.data.acf.cta
        // this.sayings = response.data.acf.bsd_sayings
        var sayings = response.data.acf.bsd_sayings.map(obj => {
          console.log(obj.bsd_saying)
          return obj.bsd_saying
        })
        sayings.forEach(el => {
          this.sayings.push(el)
        })
        this.logoColour = response.data.acf.bsd_logo_colour
      }).catch(function (error) {
        console.log(error)
      })
    }
  },
  beforeMount () {

  },
  mounted () {
    // this.initScroll()
    this.getData()
    console.log(this.sayings)
    this.isMenuOpen()
    this.closeMenuDown()

    document.getElementById('bsdIcon').style.opacity = 1
    document.getElementById('bsdText').style.opacity = 0

    /* var linodes = document.getElementById('menu').childNodes
    for (var a = 0; a < linodes.length; a++) {
      // console.log(linodes[a])
      if (linodes[a].textContent !== ' ') {
        linodes[a].classList.remove('fadeIn')
      }
    } */

    this.fadeIn()
    this.canvasAnimate()
    this.startDragDrop()
  },
  beforeDestroy () {
    window.addEventListener('wheel', e => {
      // console.log('removing wheel event listener')
    })
  },
  created () {

  },
  components: {
    VueTyper
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/homepage/nutshell.vue